
import AreaChart from "@/components/chart/AreaChart";
const DEFAULT_BENCHMARKS = [
    {
        id: 54,
        name: "DAX",
        slug: "dax-index",
        logo: "DE0008469008.svg",
        isin: "DE0008469008",
        instrumentType: "Index",
        priceType: "ABS",
        primaryMarketMic: "XETR",
        mic: "XETR",
        portfolioId: 147336,
        numSubscribers: null,
        creator: null,
        currency: "IDX",
        color: "#1f77b4",
        available: true
    },
    {
        id: 0,
        name: "EUR/USD US DOLLAR",
        slug: "eur-usd-us-dollar-wahrung",
        logo: "EU0009652759.gif",
        isin: "EU0009652759",
        instrumentType: "Währung",
        priceType: "ABS",
        primaryMarketMic: "FX",
        mic: "FX",
        portfolioId: 157420,
        numSubscribers: null,
        creator: null,
        currency: "USD",
        color: "#ff7f0e",
        available: true
    },
    {
        id: 0,
        name: "VANG.FTSE A.W. DLA",
        slug: "vang-ftse-a-w-dla-etf",
        logo: "fallback/4.png",
        isin: "IE00BK5BQT80",
        instrumentType: "ETF",
        priceType: "ABS",
        primaryMarketMic: "XDUB",
        mic: "XDUB",
        portfolioId: 162522,
        numSubscribers: null,
        creator: null,
        currency: "EUR",
        color: "#b044ca",
        available: true
    },
    {
        id: 0,
        name: "VIX",
        slug: "vix-index",
        logo: "US12497K1007.png",
        isin: "US12497K1007",
        instrumentType: "Index",
        priceType: "ABS",
        primaryMarketMic: "XCBO",
        mic: "XCBO",
        portfolioId: 173516,
        numSubscribers: null,
        creator: null,
        currency: "IDX",
        color: "#d62728",
        available: true
    },
    {
        id: 0,
        name: "DOW JONES",
        slug: "dow-jones-index",
        logo: "US2605661048.svg",
        isin: "US2605661048",
        instrumentType: "Index",
        priceType: "ABS",
        primaryMarketMic: "XNYS",
        mic: "XNYS",
        portfolioId: 175428,
        numSubscribers: null,
        creator: null,
        currency: "IDX",
        color: "#9467bd",
        available: true
    },
    {
        id: 0,
        name: "NASDAQ COMP.",
        slug: "nasdaq-comp-index",
        logo: "US6311011026.svg",
        isin: "US6311011026",
        instrumentType: "Index",
        priceType: "ABS",
        primaryMarketMic: "XNAS",
        mic: "XNAS",
        portfolioId: 180939,
        numSubscribers: null,
        creator: null,
        currency: "IDX",
        color: "#8c564b",
        available: true
    },
    {
        id: 0,
        name: "S&P 500",
        slug: "s-p-500-index",
        logo: "US78378X1072.svg",
        isin: "US78378X1072",
        instrumentType: "Index",
        priceType: "ABS",
        primaryMarketMic: "XNYS",
        mic: "XNYS",
        portfolioId: 183148,
        numSubscribers: null,
        creator: null,
        currency: "IDX",
        color: "#e377c2",
        available: true
    },
    {
        id: 0,
        name: "FTSE 100",
        slug: "ftse-100-index",
        logo: "GB0001383545.svg",
        isin: "GB0001383545",
        instrumentType: "Index",
        priceType: "ABS",
        primaryMarketMic: "XLON",
        mic: "XLON",
        portfolioId: 159796,
        numSubscribers: null,
        creator: null,
        currency: "IDX",
        color: "#7f7f7f",
        available: true
    },
    {
        id: 0,
        name: "BITCOIN (BTC)",
        slug: "bitcoin-crypto",
        logo: "CRYPT0000BTC.png",
        isin: "CRYPT0000BTC",
        instrumentType: "Crypto",
        priceType: "ABS",
        primaryMarketMic: "FX",
        mic: "FX",
        portfolioId: 146137,
        numSubscribers: null,
        creator: null,
        currency: "EUR",
        color: "#bcbd22",
        available: true
    }
]

export default {
    name: 'MarketAnalysisChart',
    components: {
        AreaChart,
    },
    data() {
        return {
            interval: this.$store.getters["preferences/getMarketAnalysisChartInterval"],
        }
    },

    computed: {
        intervals() {
            return [
                {
                    interval: 'day',
                    text: this.$t('common.intervals.day')
                },
                {
                    interval: 'week',
                    text: this.$t('common.intervals.week')
                },
                {
                    interval: 'month',
                    text: this.$t('common.intervals.month')
                },
                {
                    interval: '3m',
                    text: this.$t('common.intervals.threeMonths')
                },
                {
                    interval: '6m',
                    text: this.$t('common.intervals.sixMonths')
                },
                {
                    interval: 'ytd',
                    text: this.$t('common.intervals.ytd')
                },
                {
                    interval: 'year',
                    text: this.$t('common.intervals.year')
                },
                {
                    interval: '2y',
                    text: this.$t('common.intervals.twoYears')
                },
                {
                    interval: '3y',
                    text: this.$t('common.intervals.threeYears')
                },
                {
                    interval: '4y',
                    text: this.$t('common.intervals.fourYears')
                },
                {
                    interval: 'fiveyears',
                    text: this.$t('common.intervals.fiveYears')
                },
                {
                    interval: '10y',
                    text: this.$t('common.intervals.tenYears')
                },
                {
                    interval: '20y',
                    text: this.$t('common.intervals.twentyYears')
                },
                {
                    interval: 'max',
                    text: this.$t('common.intervals.max')
                }
            ]
        }
    },

    created() {
        this.defaultBenchmarks = DEFAULT_BENCHMARKS
    }
}
